import React from "react";
import {Button, Icon, Modal} from "antd";
import PropTypes from "prop-types";
import {sanitizeFieldName} from "../../util/methods";
import {fetchAssetCodeByModelId, fetchSubElementFilter, findAssetModelBySubType} from "../../appRedux/actions";
import AssetCreate from "../../containers/Asset/create";
import {connect} from "react-redux";

class AssetModal extends React.Component {

  id = 0;

  state = {
    modalOpen: 1,
    visible: false,
    assetDataList: []
  };

  componentDidMount() {
    this.props.fetchSubElementFilter('Asset');
    const {data = []} = this.props;
    let obj = {
      assetDataList: data,
    };
    if (data && data.length) {
      obj = {
        modalOpen: 0,
        assetDataList: data,
      }
    }

    if(this.props.dependentAsset && this.props.openModal) {
      this.setState({modalOpen: 0, visible: true});
    }

    // if(this.props.dependentAsset && this.props.title !== 'CREATE' && !this.props.openModal)
    // {
    //   let sData=[];
    //   sData.push(data);
    //   obj.assetDataList = sData;
    //   console.log('mounted',obj);
    // }
    this.setState(obj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        assetDataList: nextProps.data,
        modalOpen: 0,
      })
    }
  }

  remove = index => {
    const {assetDataList} = this.state;
    assetDataList.splice(index, 1);
    this.setState({
      assetDataList: assetDataList,
      modalOpen: 1,
    }, ()=> {
      this.props.removeStateAsset(index);
      // this.props.getAssetData(assetDataList);
    });
  };

  removeDependent = (index, innerIndex) => {
    const {assetDataList} = this.state;
    assetDataList.splice(index, 1);
    this.setState({
      assetDataList: assetDataList,
      modalOpen: 1,
    }, ()=> {
      this.props.removeStateDependentAsset(index, innerIndex);
    });
  }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleChange = (e) => {
  };

  handleSubmit = (values, id) => {
    const {assetDataList} = this.state;
    // todo complete it according to data
    const data = values;
    assetDataList.push(data);
    this.setState({
      assetDataList: assetDataList,
      visible: false,
      modalOpen: 0
    }, ()=> {
      this.props.getAssetData(assetDataList);
    });
  };

  handleDependentAssetSubmit = (values, id) => {
    const {assetDataList} = this.state;
    // todo complete it according to data
    const data = values;
      assetDataList.push(data);
    this.setState({
      assetDataList: assetDataList,
      visible: false,
      modalOpen: 0
    }, ()=> {
      this.props.getDependentAssetData(assetDataList);
    });
  };

  edit = (id) => {
    this.props.history.push(`/asset/edit/${id}`);
  };

  getIdValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string' || typeof value === 'number') return `${value}`;
    if (typeof value === 'object') return `${value._id || value.id || ''}`;
    return '';
  };

  getSubTypeNameFromFilters = (subTypeId) => {
    if (!subTypeId) {
      return '';
    }
    const options = this.props
      && this.props.subAssetFilters
      && this.props.subAssetFilters.equipmentSubType
      && this.props.subAssetFilters.equipmentSubType.data
      && this.props.subAssetFilters.equipmentSubType.data.data || [];
    const found = (options || []).find((item) => `${item && item._id}` === `${subTypeId}`);
    return found && found.name ? found.name : '';
  };

  resolveEquipmentSubTypeName = (item) => {
    if (!item) {
      return '';
    }
    const directSubType = item.equipmentSubType;
    if (directSubType && typeof directSubType === 'object' && directSubType.name) {
      return directSubType.name;
    }
    const directSubTypeId = this.getIdValue(directSubType);
    if (directSubTypeId) {
      const fromFilter = this.getSubTypeNameFromFilters(directSubTypeId);
      if (fromFilter) {
        return fromFilter;
      }
    }
    const modelSubType = item.assetModel && item.assetModel.assetSubType;
    if (modelSubType && typeof modelSubType === 'object' && modelSubType.name) {
      return modelSubType.name;
    }
    return '';
  };

  formItems() {
    const {isDisabled, title} = this.props;
    const { assetDataList } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      justifyContent: 'space-between'
    };

    return assetDataList.map((item, index) => {
      const equipmentSubTypeName = this.resolveEquipmentSubTypeName(item);
      return <div key={index} style={style}>
        <div>
          {
            item.altName && <div>Alt Name: {item.altName}</div>
          }
          {
            item.assetCode && <div>
              Asset Code: {item.assetCode}
            </div>
          }
          {
            item['assetModel'] && item['assetModel']['name'] && <div>
              Asset Model: {item['assetModel']['name']}
            </div>
          }
          {equipmentSubTypeName && <div>Asset Sub Type: {equipmentSubTypeName}</div>}
        </div>
        <div>
          {item._id ? <Button type='primary' disabled={isDisabled} onClick={() => {this.edit(item._id)}}>Edit</Button> : ''}
          {
            (title === 'EDIT' && item.assetId) ? <Button onClick={() => {this.edit(item.assetId)}}>
              Edit
            </Button> : this.props.dependentAsset ?
              '' : <Button
                type='danger'
                disabled={isDisabled}
                onClick={() => this.remove(`${index}`)}
              >Remove</Button>
          }
        </div>
      </div>
    });
  }

  render() {
    const { item, isDisabled, subAssetFilters, data, history, match, fetchAssetCodeByModelId, assetCode, title, dependentAsset } = this.props;
    const { modalOpen, visible } = this.state;
    const subFilters = Object.assign({}, subAssetFilters);
    delete subFilters.documents;
    delete subFilters.location;
    delete subFilters.client;
    delete subFilters.rate;

    return (
      <div>
        <Modal
          title="Add Asset"
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <AssetCreate data={data}
                          getLinkedAssetData = {this.props.getLinkedAssetData}
                          index = {this.props.index}
                          filters={subFilters}
                          subMaster={true}
                          useAssetModelInlineCreate={this.props.useAssetModelInlineCreate}
                          modules={''}
                          saveOwner = {this.props.saveOwner}
                          owner = {this.props.owner || ''}
                          title={'CREATE'}
                          findAssetModelBySubType = {this.props.findAssetModelBySubType}
                          assetModel = {this.props.assetModel}
                          resource={item && item.options.asset.ref}
                          fetchAssetCodeByModelId={fetchAssetCodeByModelId}
                          assetCode={assetCode}
                          loading={false}
                          onChange={this.handleChange}
                          dependent={dependentAsset}
                          fromModal = {true}
                          onSubmit={dependentAsset ? this.handleDependentAssetSubmit : this.handleSubmit }
                          history={history}
                          match={match}
          />
        </Modal>
        {this.formItems()}
        <br/>
        {
          !this.props.dependentAsset && modalOpen > 0 && <Button disabled={isDisabled} type="dashed" onClick={this.showModal} style={{width: '60%', marginTop: '15px'}}>
            <Icon type="plus"/> Add {(item && item.field && sanitizeFieldName(item.field)) || 'Asset'}
          </Button>
        }
      </div>

    )
  }
}

const mapStateToProps = ({commonData, asset}) => {
  return {
    subAssetFilters: commonData.subElementFilters,
    assetCode: asset.assetCode,
    assetModel: asset.assetModel
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubElementFilter,
    fetchAssetCodeByModelId,
    findAssetModelBySubType
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(AssetModal);
AssetModal.defaultProps = {};

AssetModal.propTypes = {
  item: PropTypes.object
};
